import { CoreEnv } from '@eb/context-gen';
import { DE_CURRENCY_FORMAT } from '@eb/intl';

export const ENV_PROP_FIXTURE: CoreEnv = {
    serverUrl: 'serverUrl',
    ebDomain: 'ebDomain',
    adminServerUrl: 'adminServerUrl',
    signupUrl: 'signupUrl',
    loginUrl: 'loginUrl',
    signinUrl: 'loginUrl',
    logoutUrl: 'logoutUrl',
    searchLocation: {
        address: 'Godoy Cruz, Argentina',
        latitude: -32.0,
        longitude: -68.0,
    },
    currencyFormat: DE_CURRENCY_FORMAT,
    locales: [
        {
            locale: 'es_AR',
            locale_name: 'Argentina',
            localized_language_name: 'localized',
        },
        {
            locale: 'en_AU',
            locale_name: 'Australia',
            localized_language_name: 'localized',
        },
        {
            locale: 'nl_BE',
            locale_name: 'België',
            localized_language_name: 'localized',
        },
        {
            locale: 'fr_BE',
            locale_name: 'Belgique',
            localized_language_name: 'localized',
        },
        {
            locale: 'pt_BR',
            locale_name: 'Brasil',
            localized_language_name: 'localized',
        },
        {
            locale: 'en_CA',
            locale_name: 'Canada (EN)',
            localized_language_name: 'localized',
        },
        {
            locale: 'fr_CA',
            locale_name: 'Canada (FR)',
            localized_language_name: 'localized',
        },
        {
            locale: 'es_CL',
            locale_name: 'Chile',
            localized_language_name: 'localized',
        },
        {
            locale: 'es_CO',
            locale_name: 'Colombia',
            localized_language_name: 'localized',
        },
        {
            locale: 'de_DE',
            locale_name: 'Deutschland',
            localized_language_name: 'localized',
        },
        {
            locale: 'es_ES',
            locale_name: 'España',
            localized_language_name: 'localized',
        },
        {
            locale: 'fr_FR',
            locale_name: 'France',
            localized_language_name: 'localized',
        },
        {
            locale: 'en_HK',
            locale_name: 'Hong Kong',
            localized_language_name: 'localized',
        },
        {
            locale: 'en_IE',
            locale_name: 'Ireland',
            localized_language_name: 'localized',
        },
        {
            locale: 'it_IT',
            locale_name: 'Italia',
            localized_language_name: 'localized',
        },
        {
            locale: 'es_MX',
            locale_name: 'Mexico',
            localized_language_name: 'localized',
        },
        {
            locale: 'nl_NL',
            locale_name: 'Nederland',
            localized_language_name: 'localized',
        },
        {
            locale: 'en_NZ',
            locale_name: 'New Zealand',
            localized_language_name: 'localized',
        },
        {
            locale: 'de_AT',
            locale_name: 'Österreich',
            localized_language_name: 'localized',
        },
        {
            locale: 'es_PE',
            locale_name: 'Peru',
            localized_language_name: 'localized',
        },
        {
            locale: 'pt_PT',
            locale_name: 'Portugal',
            localized_language_name: 'localized',
        },
        {
            locale: 'en_SG',
            locale_name: 'Singapore',
            localized_language_name: 'localized',
        },
        {
            locale: 'en_GB',
            locale_name: 'United Kingdom',
            localized_language_name: 'localized',
        },
        {
            locale: 'en_US',
            locale_name: 'United States',
            localized_language_name: 'localized',
        },
    ],
    localeInfo: {
        tld: '.de',
        locale: 'de_DE',
        locale_name: 'Deutschland',
        contact_us_path: 'localeContactUsPath',
        contact_us_url: 'localeContactUsUrl',
        sales_contact_landing_page: 'localeSalesContactLanding',
        sales_contact_link_text: 'localeSalesContactLinkText',
        twitter_page: 'localeTwitter',
        twitter_handle: 'localeTwitterHandle',
        facebook_page: 'localeFacebookPage',
        facebook_locale: 'localeFacebook',
        linked_in_page: 'localeLinkedIn',
        instagram_page: 'localeInstagram',
        blog_url: 'localeBlog',

        address_1: '',
        address_2: '',
        address_3: '',
        address_4: '',
        adobe_reader_url: '',
        alt_phone_number: '',
        android_attendee_app_url: '',
        android_entrymanager_url: '',
        app_store_available_icon_url: '',
        app_store_download_icon_url: '',
        attendee_support_phone_number: '',
        available_for_event_listing_override: '',
        base_adobe_download_url: '',
        base_android_app_badge_url: '',
        base_android_app_url: '',
        base_android_entrymanager_url: '',
        base_app_store_available_icon_url: '',
        base_app_store_download_icon_url: '',
        base_flag_logo_url: '',
        base_ios_app_badge_url: '',
        base_ios_app_url: '',
        base_ios_entrymanager_url: '',
        base_medium_logo_url: '',
        base_play_store_badge_url: '',
        contact_sales_form_phone_number: '',
        contact_sales_phone_number: '',
        contact_us_sales_phone_number: '',
        contact_us_show_chat_button: false,
        country_code: '',
        default_adobe_download_url: '',
        default_currency: '',
        default_language: '',
        default_language_name: '',
        default_location_for_tld: {
            city: '',
            country: '',
            country_code: '',
            latitude: 0,
            longitude: 0,
            postal_code: '',
            region: '',
            region_code: '',
        },
        default_paper_size: '',
        default_professional_package: false,
        default_timezone: '',
        domain: '',
        feature_flag: '',
        first_week_day: 0,
        first_week_day_from_sunday: 0,
        flag_logo_medium_url: '',
        flag_logo_url: '',
        from_mail_charity: '',
        from_mail_ebhelp: '',
        from_mail_installments: '',
        from_mail_order: '',
        get_default_location_dict: {
            city: '',
            country: '',
            country_code: '',
            latitude: 0,
            longitude: 0,
            postal_code: '',
            region: '',
            region_code: '',
        },
        get_default_location_name: '',
        gold_support_phone_number: '',
        google_analytics_url: '',
        google_maps_language: '',
        greetings: [],
        group: '',
        has_localized_support_team: false,
        has_phone_support: false,
        hiw_sales_phone_number: '',
        hreflang: '',
        ios_attendee_app_url: '',
        ios_entrymanager_url: '',
        is_deferred_payment_options_allowed: false,
        is_eventioz_locale: false,
        is_latam: false,
        is_locale_enabled: false,
        language_code: '',
        latitude: 0,
        live_ops_support_phone_number: '',
        localized_country_name: '',
        localized_language_name: '',
        longitude: 0,
        music_microsite_url: '',
        music_url: '',
        nonprofit_501c3_fax_number: '',
        npo_email: '',
        npo_service_fee_charge: '',
        npo_service_fee_percent: '',
        old_event_locale: '',
        on_demand_payout_allowed: false,
        organizations_support_phone_number: '',
        outside_us_organizer_phone_number: '',
        outside_us_phone_number: '',
        paypal_locale: '',
        paypal_locale_lc: '',
        paypal_support_number: '',
        play_store_badge_url: '',
        prefixes: [],
        press_blog_url: '',
        press_email: '',
        recaptcha_language: '',
        sales_email: '',
        sales_hours: '',
        sales_phone_and_hours: '',
        sales_phone_number: '',
        salesforce_chat_config: {
            t_args: [],
            language: '',
            live_agent: '',
            locale: '',
            script_source: '',
        },
        server: '',
        show_cookie_policy_bar: false,
        show_link_to_music_microsite: false,
        show_support_special_hours_on_contact_us: false,
        silver_support_phone_number: '',
        skip_package_selection: false,
        ssl_server: '',
        support_number_hours: '',
        support_number_summer_hours: '',
        support_number_winter_hours: '',
        support_phone: '',
        support_phone_number: '',
        support_team_landing_page: '',
        support_team_link_text: '',
        terms_of_service_url: '',
        tos_path: '',
        uses_metric_system: false,
    },
    helpUrls: {
        home: '/helphome',
        impressum: '/helpimpressum',
        suggested: [],
    },
    organizeUrls: {
        home: {
            url: 'organizeUrl',
            label: 'organizeUiLabel',
            gaLabel: 'organizeGaLabel',
        },
        suggested: [],
    },
    isEmbeddedView: false,
    isMobile: false,
    showCookieHeader: false,
    wasRenderedServerSide: false,
    searchQuery: '',
};
export const USER_PROP_FIXTURE = {
    publicId: '226753142328',
    email: 'eng@eventbrite.com',
    fullName: 'Eventbrite Developer',
    firstName: 'Eventbrite',
    lastName: 'Developer',
    isAuthenticated: true,
    hasEvents: true,
    hasOrganizers: true,
    canCreateEvents: true,
    canUseStudio: true,
    isAttendee: false,
    thumbnailUrl: 'https://path.com/to/image',
    numOrders: 6,
    numSavedEvents: 52,
    numFollowing: 22,
    canInvite: true,
    canUseSponsorships: true,
    canUseCredits: true,
    hasTikibar: false,
    isStaff: false,
};

export const USER_UNKNOWN_PROP_FIXTURE = {
    hasTikibar: false,
    publicId: null,
    hasEvents: false,
    hasOrganizers: false,
    usesNewPermissions: false,
    isStaff: false,
    canUseStudio: false,
    canInvite: false,
    fullName: null,
    thumbnailUrl: null,
    numOrders: 0,
    firstName: null,
    hasGlobalPermissions: false,
    isAttendee: false,
    lastName: null,
    activeOrganization: null,
    hasContactsPermission: false,
    canCreateEvents: false,
    canUseInterests: true,
    email: null,
    isAuthenticated: false,
    orgHasEvents: false,

    numSavedEvents: 52,
    numFollowing: 22,
    canUseSponsorships: true,
    canUseCredits: true,
};

export const USER_ATTENDEE_PROP_FIXTURE = {
    hasTikibar: false,
    publicId: '123456',
    hasEvents: false,
    hasOrganizers: false,
    usesNewPermissions: true,
    isStaff: false,
    canUseStudio: false,
    canInvite: false,
    fullName: 'randomemail@gmail.com',
    thumbnailUrl: null,
    numOrders: 2,
    firstName: null,
    hasGlobalPermissions: false,
    isAttendee: false,
    lastName: null,
    activeOrganization: null,
    hasContactsPermission: false,
    canCreateEvents: false,
    canUseInterests: true,
    email: 'randomemail@gmail.com',
    isAuthenticated: true,
    orgHasEvents: false,

    numSavedEvents: 52,
    numFollowing: 22,
    canUseSponsorships: true,
    canUseCredits: true,
};
export const USER_ORGANIZER_PROP_FIXTURE = {
    hasTikibar: false,
    publicId: '123456',
    hasEvents: false,
    hasOrganizers: true,
    usesNewPermissions: true,
    isStaff: false,
    canUseStudio: false,
    canInvite: false,
    fullName: 'randomemail@gmail.com',
    thumbnailUrl: null,
    numOrders: 2,
    firstName: null,
    hasGlobalPermissions: false,
    isAttendee: false,
    lastName: null,
    activeOrganization: {
        _type: 'organization',
        name: '',
        vertical: 'default',
        parent_id: null,
        locale: null,
        image: null,
        image_id: null,
        id: '98765',
    },
    hasContactsPermission: true,
    canCreateEvents: true,
    canUseInterests: true,
    email: 'randomemail@gmail.com',
    isAuthenticated: true,
    orgHasEvents: true,

    numSavedEvents: 52,
    numFollowing: 22,
    canUseSponsorships: true,
    canUseCredits: true,
};
export const USER_ADMIN_PROP_FIXTURE = {
    hasTikibar: true,
    publicId: '123456',
    hasEvents: true,
    hasOrganizers: true,
    usesNewPermissions: false,
    isStaff: true,
    canUseStudio: false,
    canInvite: false,
    fullName: 'FirstName LastName',
    thumbnailUrl: null,
    numOrders: 0,
    firstName: 'FirstName',
    hasGlobalPermissions: true,
    isAttendee: false,
    lastName: 'LastName',
    activeOrganization: null,
    hasContactsPermission: true,
    canCreateEvents: true,
    canUseInterests: true,
    email: 'randomemail@gmail.com',
    isAuthenticated: true,
    orgHasEvents: true,

    numSavedEvents: 52,
    numFollowing: 22,
    canUseSponsorships: true,
    canUseCredits: true,
};
export const FEATURE_FLAGS_FIXTURE = {
    launchCreatorCreditsSectionAttendee: true,
};
